import { useState } from 'react'

import {
  Card,
  Button,
  Divider,
  InlineGrid,
  Icon,
  Text,
  BlockStack,
  Modal,
  InlineStack,
  Checkbox,
  Link,
  TextField,
  Banner,
  ButtonGroup
} from '@shopify/polaris'

import {
  CheckIcon, LogoGoogleIcon,
} from '@shopify/polaris-icons'
import { usePartnerUp } from '../providers/PartnerUpStoreProvider';


export default function ChooseASubscriptionPanel({ showHeader = true }) {

  const {
    subscribeLoading,
    createSubscription,
    cancelSubscription,
    store,
    user,
    auth,
    subscriptions
  } = usePartnerUp();

  const [cancelAreYouSure, setCancelAreYouSure] = useState(false);
  const [cancelReason, setCancelReason] = useState('');
  const [confirmCancel, setConfirmCancel] = useState(false);

  const subscriptionName = store?.appSubscription?.name;

  const credits = (user?.credits || 0) + (user?.fixedCredits || 0)

  console.log('appsub', store?.appSubscription)

  const activeSub = subscriptions?.find(s => s.status === 'active');

  console.log('env', process.env.NODE_ENV)

  return (
    <>
      <Modal
        open={cancelAreYouSure}
        onClose={() => setCancelAreYouSure(false)}
        title="Are you sure you want to cancel?"
        primaryAction={{
          content: 'Yes, Cancel Subscription',
          disabled: !confirmCancel || !cancelReason,
          destructive: true,
          loading: subscribeLoading,
          onAction: () => cancelSubscription(() => setCancelAreYouSure(false), cancelReason)
        }}
        secondaryActions={[
          {
            content: 'No, Keep Subscription',
            onAction: () => setCancelAreYouSure(false)
          }
        ]}>

        <Modal.Section>
          <BlockStack gap="400">
            <BlockStack>
              <Text variant="headingMd">Your account will become "read-only" as of {new Date(store?.appSubscription?.currentPeriodEnd)?.toLocaleDateString()}</Text>
              <Text variant="bodyMd">After this date, you will lose access to search, campaigns, payments, and posts</Text>
            </BlockStack>
            <InlineStack align="end">
              <Checkbox label="I understand" checked={confirmCancel} onChange={() => setConfirmCancel(!confirmCancel)} />
            </InlineStack>
          </BlockStack>
        </Modal.Section>
        <Modal.Section>
          <TextField multiline={2} label="Reason for cancellation" value={cancelReason} onChange={v => setCancelReason(v)} />
        </Modal.Section>
      </Modal>
      <BlockStack gap="400">
        {
          showHeader ? (
            <BlockStack>
              <Banner tone={credits ? "info" : 'critical'} >
                <BlockStack gap="100">
                  {
                    credits ? (
                      <Text variant="headingMd">
                        You have {credits} Credits {' '}
                      </Text>
                    ) : (
                      <Text variant="headingMd">
                        You're Out of Credits {' '}
                      </Text>
                    )
                  }
                  {
                    activeSub ? (
                      <Text variant="bodySm" tone="subdued">
                        {
                          user?.fixedCredits ? `${user?.fixedCredits} Non-Expiring Fixed Credits. ` : ''
                        }
                        {
                          activeSub?.cancelledDate ? 'Cancelled. Subscription Ends ' + new Date(activeSub?.cancelledDate)?.toLocaleDateString() : 'Credits Reset on' + new Date(activeSub?.renewDate)?.toLocaleDateString()
                        }
                      </Text>
                    ) : (
                      <Text variant="bodySm" tone="subdued">
                        {
                          user?.fixedCredits ? `${user?.fixedCredits} Non-Expiring Fixed Credits. ` : ''
                        }
                        <Link url="">Choose a Subscription</Link>
                        {' '} for More.
                      </Text>
                    )
                  }
                </BlockStack>
              </Banner>
            </BlockStack>
          ) : null
        }
        <InlineGrid gap="400" columns="3">
          <BlockStack gap="400">
            <Card roundedAbove="sm" background="bg-success-subdued-hover">
              <BlockStack gap="400">
                <BlockStack gap="100" inlineAlign="center">
                  <Text variant="headingMd">Starter</Text>
                  <Text variant="headingXl">$47 / month</Text>
                </BlockStack>
                {
                  activeSub?.amount_total === 4700 ? (
                    <BlockStack gap="100">
                      <Button variant="primary" url={
                        process.env.NODE_ENV === 'development'
                          ? "https://buy.stripe.com/test_bIY4hJ4hr7xhaY03ce?client_reference_id=" + auth.currentUser?.uid
                          : "https://buy.stripe.com/cN2179ca9gfv6g87sw?client_reference_id=" + auth.currentUser?.uid}>Get More Credits</Button>
                      <Button url={
                        process.env.NODE_ENV === 'development'
                          ? "https://billing.stripe.com/p/login/test_9AQ03Vc35fbm1Lq6oo"
                          : "https://billing.stripe.com/p/login/3csg0S0TzgC3dFe4gg"
                      } plain>Manage Subscription</Button>
                    </BlockStack>
                  ) : activeSub ? (
                    <Button
                      loading={subscribeLoading === 'starter'}
                      disabled={subscribeLoading && subscribeLoading !== 'starter'}
                      onClick={() => createSubscription('starter')}>
                      Downgrade to Starter
                    </Button>
                  ) : (
                    <Button
                      loading={subscribeLoading === 'starter'}
                      disabled={subscribeLoading && subscribeLoading !== 'starter'}
                      variant="primary"
                      size="large"
                      url={
                        process.env.NODE_ENV === 'development'
                          ? "https://buy.stripe.com/test_00gcOf6pzg3Ngik288?client_reference_id=" + auth.currentUser?.uid
                          : "https://buy.stripe.com/5kA4jlca9bZf7kc003?client_reference_id=" + auth.currentUser?.uid
                      }>
                      {'Subscribe to Starter'}
                    </Button>
                  )
                }
                <Divider />
                <BlockStack inlineAlign="center" gap="200">
                  {[
                    '50 Profiles / Month',
                    '$1.00 / Profile After',
                  ].map((feature, i) => (
                    <InlineStack key={i} gap="100">
                      <Icon source={CheckIcon} tone="success" />
                      <Text>{feature}</Text>
                    </InlineStack>
                  ))}
                </BlockStack>
              </BlockStack>
            </Card>
          </BlockStack>
          <BlockStack gap="300">
            <Card roundedAbove="sm">
              <BlockStack gap="400">
                <BlockStack gap="100" inlineAlign="center">
                  <Text variant="headingMd">Standard</Text>
                  <Text variant="headingXl">$147 / month</Text>
                </BlockStack>
                {
                  activeSub?.amount_total === 14700 ? (
                    <BlockStack gap="100">
                      <Button disabled>Current Plan</Button>
                      <Button variant="primary" url={
                        process.env.NODE_ENV === 'development'
                          ? "https://buy.stripe.com/test_bIY4hJ4hr7xhaY03ce?client_reference_id=" + auth.currentUser?.uid
                          : "https://buy.stripe.com/7sIaHJ0rr4wN8og7sx?client_reference_id=" + auth.currentUser?.uid}>Get More Credits</Button>
                      <Button url={
                        process.env.NODE_ENV === 'development'
                          ? "https://billing.stripe.com/p/login/test_9AQ03Vc35fbm1Lq6oo"
                          : "https://billing.stripe.com/p/login/3csg0S0TzgC3dFe4gg"
                      } plain>Manage Subscription</Button>
                    </BlockStack>
                  ) : activeSub ? (
                    <Button
                      loading={subscribeLoading === 'standard'}
                      disabled={subscribeLoading && subscribeLoading !== 'standard'}
                      url={
                        process.env.NODE_ENV === 'development'
                          ? "https://billing.stripe.com/p/login/test_9AQ03Vc35fbm1Lq6oo"
                          : "https://billing.stripe.com/p/login/3csg0S0TzgC3dFe4gg"
                      }>
                      Upgrade to Standard
                    </Button>
                  ) : (
                    <Button
                      loading={subscribeLoading === 'standard'}
                      disabled={subscribeLoading && subscribeLoading !== 'standard'}
                      size="large"
                      url={
                        process.env.NODE_ENV === 'development'
                          ? "https://billing.stripe.com/p/login/test_9AQ03Vc35fbm1Lq6oo"
                          : "https://buy.stripe.com/4gw2bd6PPfbr6g88wx?client_reference_id=" + auth.currentUser?.uid
                      }>
                      {'Subscribe to Standard'}
                    </Button>
                  )
                }
                <Divider />
                <BlockStack inlineAlign="center" gap="200">
                  {[
                    '200 Profiles / Month',
                    '$0.85 / Profile After',
                  ].map((feature, i) => (
                    <InlineStack key={i} gap="100">
                      <Icon source={CheckIcon} tone="success" />
                      <Text>{feature}</Text>
                    </InlineStack>
                  ))}
                </BlockStack>
              </BlockStack>
            </Card>
          </BlockStack>
          <BlockStack gap="300">
            <Card roundedAbove="sm">
              <BlockStack gap="400">
                <BlockStack gap="100" inlineAlign="center">
                  <Text variant="headingMd">Scale</Text>
                  <Text variant="headingXl">$597 / month</Text>
                </BlockStack>
                {
                  activeSub?.amount_total === 59700 ? (
                    <BlockStack gap="100">
                      <Button disabled>Current Plan</Button>
                      <Button variant="primary" url={
                        process.env.NODE_ENV === 'development'
                          ? "https://buy.stripe.com/test_bIY4hJ4hr7xhaY03ce?client_reference_id=" + auth.currentUser?.uid
                          : "https://buy.stripe.com/7sI7vxgqp4wNdIAfZ4?client_reference_id=" + auth.currentUser?.uid}>Get More Credits</Button>
                      <Button url={
                        process.env.NODE_ENV === 'development'
                          ? "https://billing.stripe.com/p/login/test_9AQ03Vc35fbm1Lq6oo"
                          : "https://billing.stripe.com/p/login/3csg0S0TzgC3dFe4gg"
                      } plain>Manage Subscription</Button>
                    </BlockStack>
                  ) : activeSub ? (
                    <Button
                      loading={subscribeLoading === 'scale'}
                      disabled={subscribeLoading && subscribeLoading !== 'scale'}
                      size="large"
                      url={
                        process.env.NODE_ENV === 'development'
                          ? "https://billing.stripe.com/p/login/test_9AQ03Vc35fbm1Lq6oo"
                          : "https://billing.stripe.com/p/login/3csg0S0TzgC3dFe4gg"
                      }>
                      Upgrade to Scale
                    </Button>
                  ) : (
                    <Button
                      loading={subscribeLoading === 'scale'}
                      disabled={subscribeLoading && subscribeLoading !== 'scale'}
                      size="large"
                      url={
                        process.env.NODE_ENV === 'development'
                          ? "https://billing.stripe.com/p/login/test_9AQ03Vc35fbm1Lq6oo"
                          : "https://buy.stripe.com/eVadTV5LLaVbdIA5km?client_reference_id=" + auth.currentUser?.uid
                      }
                    >
                      {'Subscribe to Scale'}
                    </Button>
                  )
                }
                <Divider />
                <BlockStack inlineAlign="center" gap="200">
                  {[
                    '1,000 Profiles / Month',
                    '$0.75 / Profile After',
                  ].map((feature, i) => (
                    <InlineStack key={i} gap="100">
                      <Icon source={CheckIcon} tone="success" />
                      <Text>{feature}</Text>
                    </InlineStack>
                  ))}
                </BlockStack>
              </BlockStack>
            </Card>
          </BlockStack>
        </InlineGrid>
      </BlockStack>
    </>
  )
}
